export default [
  {
    title: 'مدیریت بخشنامه ها',
    icon: 'bx bx-store',
    children: [
      {
        title: 'بخشنامه ها',
        route: { name: 'circular' },
        resource: 'CircularManager',
        action: 'show',
      },
      {
        title: 'نوع های فرآیند',
        route: { name: 'circularprocesstype' },
        resource: 'CircularProcessTypeManager',
        action: 'show',
      },
      {
        title: 'نوع های سند',
        route: { name: 'circulardocumenttype' },
        resource: 'CircularDocumentTypeManager',
        action: 'show',
      },
    ],
  },
]
